module.exports = __webpack_public_path__ + "static/media/D8.357f1eea.png";